// extracted by mini-css-extract-plugin
export default {"toggle":"drawer-toggle_toggle__eFUsW"};